import { Component, OnInit } from '@angular/core';
import { HomeComponent } from '../../home/home.component';
import { UserService } from '../../services/user/user.service';
import { User } from '../../model/user.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtService } from '../../auth/jwt.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  isLoginError: boolean = false;
  isLoading: boolean = false;

  constructor(private homeComponent: HomeComponent,
    private userService: UserService, private router: Router,
    private jwtServices: JwtService) { }

  ngOnInit() {
  }


  ShowRegister() {
    this.homeComponent.showregisterscreen = true;
    this.homeComponent.showloginscreen = false;
  }

  OnSubmit(Email, password) {

    this.isLoading = true;
    this.userService.userAuthentication(Email, password).subscribe((data: any) => {
      if (data.accessToken != null && data != "false") {
        //localStorage.setItem('userToken', data.accessToken);
        this.jwtServices.saveToken(data.accessToken);
        this.userService.setAuth(data);
        this.router.navigate(['/dashboard']);
        // window.location.href = "http://localhost:4200/dashboard";
        this.isLoading = false;
      }
      else {
        this.isLoginError = true;
        this.isLoading = false;
      }

    },
      (err: HttpErrorResponse) => {
        this.isLoginError = true;
        this.isLoading = false;
      });
  }

  ShowForgot() {
    this.homeComponent.showregisterscreen = false;
    this.homeComponent.showloginscreen = false;
    this.homeComponent.showforgotscreen = true;
  }

}
